import * as store from '@daas-consulting/core-frontend-store';

export const context = 'patients';
export const feature = 'age_groups';
export const name = store.getName({ context, feature });
